if (!customElements.get('horacio-navigation')) {
  customElements.define('horacio-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const mobile = this.dataset.mode === 'mobile';
      const root = this.querySelector('[data-hn-root]');
      const panel = this.querySelector('.hn-mobile-panel');
      const categories = [...this.querySelectorAll('[data-hn-category]')];
      const desktop = matchMedia('(min-width:990px)');
      const setTop = () => {
        if (!root?.open) return;
        const header = this.closest('.header');
        this.style.setProperty('--hn-menu-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
      };
      const close = (restore = false) => {
        if (root?.open) {
          root.open = false;
          document.body.classList.remove('hn-nav-open');
          if (typeof removeTrapFocus === 'function') removeTrapFocus(restore ? root.querySelector('summary') : undefined);
        }
        categories.forEach(details => { details.open = false; });
      };
      categories.forEach(details => {
        const summary = details.querySelector('summary');
        summary.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (!details.open) return;
          categories.forEach(other => { if (other !== details) other.open = false; });
          details.querySelectorAll('img[data-hn-src]').forEach(image => {
            image.src = image.dataset.hnSrc;
            image.removeAttribute('data-hn-src');
          });
        }, { signal });
      });
      if (root) {
        root.addEventListener('toggle', () => {
          root.querySelector('summary').setAttribute('aria-expanded', String(root.open));
          document.body.classList.toggle('hn-nav-open', root.open);
          if (root.open) {
            setTop();
            if (typeof trapFocus === 'function') trapFocus(panel, panel.querySelector('[data-hn-close]'));
          } else if (typeof removeTrapFocus === 'function') removeTrapFocus();
        }, { signal });
        this.querySelector('[data-hn-close]').addEventListener('click', () => close(true), { signal });
        window.addEventListener('resize', setTop, { signal });
        window.addEventListener('scroll', setTop, { signal, passive:true });
        this.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close(), { signal }));
      }
      document.addEventListener('pointerdown', event => {
        if (!mobile && !this.contains(event.target)) close();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        const opened = event.target.closest('[data-hn-category][open]');
        if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
        else close(true);
      }, { signal });
      desktop.addEventListener('change', () => close(), { signal });
      signal.addEventListener('abort', () => close(), { once:true });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
